var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22678_151419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.116 4.54029C14.4685 4.1879 14.6665 3.70993 14.6666 3.21152C14.6666 2.71311 14.4687 2.23509 14.1163 1.88262C13.7639 1.53015 13.286 1.33209 12.7876 1.33203C12.2892 1.33197 11.8111 1.5299 11.4587 1.88229L2.56133 10.7816C2.40654 10.936 2.29207 11.126 2.228 11.335L1.34733 14.2363C1.3301 14.2939 1.3288 14.3552 1.34356 14.4135C1.35833 14.4719 1.38861 14.5251 1.43119 14.5676C1.47378 14.6101 1.52708 14.6403 1.58544 14.655C1.64379 14.6697 1.70504 14.6683 1.76266 14.651L4.66466 13.771C4.87344 13.7075 5.06345 13.5937 5.218 13.4396L14.116 4.54029Z",
    stroke: "#2D6CDF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33203L12.6667 5.9987",
    stroke: "#2D6CDF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22678_151419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.9dd9af166afe138d9694cf814e72c74b.svg";
export { ForwardRef as ReactComponent };